import Bugsnag from "@bugsnag/js";
import BugsnagPluginVue from "@bugsnag/plugin-vue";
import XRefreshToken from "@/js/Components/XRefreshToken.vue";

function handleError(event, app) {
    if (!event?.errors || !Array.isArray(event.errors)) return true;

    let ignore = false;
    event.errors.forEach((error) => {
        if (error?.errorClass === 'AxiosError') {
            ignore = true;
            return;
        }

        ["Unable to preload CSS for", "Failed to fetch dynamically imported module"].forEach((message) => {
            if (error.errorMessage.includes(message)) {
                ignore = true;
                app.config.globalProperties.$modal(XRefreshToken, {
                    id: 'x-refresh-token'
                });
            }
        });
    });

    return !ignore;
}

export default {
    install(app, options = {}) {
        if (options.bugsnagKey) {
            Bugsnag.start({
                apiKey: options.bugsnagKey,
                plugins: [new BugsnagPluginVue()],
                onError: (event) => {
                    return handleError(event, app);
                }
            });

            app.use(Bugsnag.getPlugin('vue'));
            return;
        }

        // to catch global errors
        window.addEventListener("error", (event) => {
            handleError(event);
        }, true);

        // To catch promise unhandled rejections
        window.addEventListener("unhandledrejection", (event) => {
            let error = event.reason;
            if (!(error instanceof Error)) {
                error = new Error(typeof error === "string" ? error : JSON.stringify(error));
            }
            handleError({
                errors: [{ errorMessage: error.message }]
            }, app);
        });

        // To catch other errors
        app.config.errorHandler = (error, instance, info) => {
            handleError({
                errors: [{ errorMessage: error.message }]
            }, app);
            return true;
        }
    }
}